import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=0364711c&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"
import style0 from "./loading.vue?vue&type=style&index=0&id=0364711c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0364711c",
  null
  
)

export default component.exports